import type { UnauthApi } from '@/api';

type CategoryGroupProductsOptions = NonNullable<
  Parameters<
    (typeof UnauthApi)['get:/wello/v2/allows/home-love/main/category-group-gift-products']
  >[0]
>;

export type GiftCategoryGroupCode =
  CategoryGroupProductsOptions['query']['giftCategoryGroupType'];

export const ALL_CATEGORY_GROUP_CODE: GiftCategoryGroupCode = 'ALL';

export const GIFT_PAGE_SIZE = 20;

export const GIFT_PRODUCT_SORT_TYPE = {
  LATEST: 'LATEST',
  POPULAR: 'POPULAR',
  REVIEW_COUNT: 'REVIEW_COUNT',
} as const;

export type GiftProductSortType =
  (typeof GIFT_PRODUCT_SORT_TYPE)[keyof typeof GIFT_PRODUCT_SORT_TYPE];

const GIFT_PRODUCT_SORT_TYPE_LABEL = {
  [GIFT_PRODUCT_SORT_TYPE.LATEST]: '최근등록순',
  [GIFT_PRODUCT_SORT_TYPE.POPULAR]: '인기순',
  [GIFT_PRODUCT_SORT_TYPE.REVIEW_COUNT]: '후기 많은순',
} as const;

export const SORT_TYPE_OPTIONS = Object.entries(GIFT_PRODUCT_SORT_TYPE).map(
  ([key, value]) => ({
    label:
      GIFT_PRODUCT_SORT_TYPE_LABEL[key as keyof typeof GIFT_PRODUCT_SORT_TYPE],
    value,
  }),
);
